import type { ImportProfile, ReportType } from "../../api/client";
import { reportTypes, type FlowState } from "./types";

export interface SelectedImportProfile {
  reportType: ReportType;
  profileId: string;
  sourceVariant: string;
}

export function defaultProfileSelection(profiles: ImportProfile[]): {
  selectedProfileIds: Partial<Record<ReportType, string>>;
  sourceVariants: Partial<Record<ReportType, string>>;
} {
  const selectedProfileIds: Partial<Record<ReportType, string>> = {};
  const sourceVariants: Partial<Record<ReportType, string>> = {};
  for (const profile of profiles) {
    if (selectedProfileIds[profile.report_type]) continue;
    selectedProfileIds[profile.report_type] = profile.id;
    sourceVariants[profile.report_type] = profile.definition.default_source_variant;
  }
  return { selectedProfileIds, sourceVariants };
}

export function selectImportProfile(
  state: FlowState,
  reportType: ReportType,
  profileId: string,
): FlowState {
  const profile = state.profiles.find(
    (item) => item.id === profileId && item.report_type === reportType,
  );
  if (!profile) return { ...state, error: "所选导入配置不可用，请重新选择。" };
  return {
    ...state,
    selectedProfileIds: { ...state.selectedProfileIds, [reportType]: profile.id },
    sourceVariants: {
      ...state.sourceVariants,
      [reportType]: profile.definition.default_source_variant,
    },
    error: null,
  };
}

export function resolveImportSelections(state: FlowState): SelectedImportProfile[] | null {
  const selections: SelectedImportProfile[] = [];
  for (const reportType of reportTypes) {
    const profileId = state.selectedProfileIds[reportType];
    const profile = state.profiles.find(
      (item) => item.id === profileId && item.report_type === reportType,
    );
    const sourceVariant = state.sourceVariants[reportType];
    if (
      !profile ||
      !sourceVariant ||
      !profile.definition.source_variants.some((item) => item.code === sourceVariant)
    ) {
      return null;
    }
    selections.push({ reportType, profileId: profile.id, sourceVariant });
  }
  return selections;
}
